function initSelect() {
    $('.base-select').each(function() {
        if (this.classList.contains('nice-select')) return;

        $(this).niceSelect();
    })
}
